import { css } from '@microsoft/fast-element';
import { scrollbarStyles } from '../../../styles';

export const AutoExecuteApprovedCounterpartiesModalStyles = css`
  ${scrollbarStyles}

  fast-dialog.default-dialog::part(control) {
    background-color: #1f2126;

    --dialog-height: none;
    --dialog-width: 900px;

    border: 1px solid #2e3339;
    border-radius: 4px;
    position: relative;
  }

  .dialog-header {
    height: 56px;
    color: var(--white);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .title {
    color: #fff;
    text-align: center;
    line-height: normal;
    font-size: x-large;
    font-weight: bold;
  }

  .dialog-content {
    display: grid;
  }

  .dialog-buttons {
    display: flex;
    gap: 8px;
    justify-content: space-between;
  }

  .closing-icon {
    background: transparent;
    border: none;
    height: 32px;
    margin: 0;
    min-width: 32px;
    position: absolute;
    right: 15px;
    top: 12px;
  }

  .closing-icon:hover {
    background: var(--button-hover-bg);
  }

  .closing-icon::part(control):focus-visible {
    border: none;
    box-shadow: none;
  }

  .closing-icon:hover svg path {
    fill: var(--white);
  }

  .description {
    text-align: center;
    word-wrap: break-word;
    color: rgba(255, 255, 255, 0.6);
    font-size: 14px;
    margin: 0 50px 16px;
  }

  .confirm-button {
    float: right;
    margin: 16px 16px 16px 0;
  }

  .company-grid {
    width: 700px;
    margin: auto;
  }

  .company-grid-header {
    display: grid;
    grid-template-columns: 25% 55% 20%;
  }

  .company-grid-header-item {
    border-bottom: 1px solid #879ba6;
    color: #879ba6;
    height: 24px;
  }

  .company-approvals-grid {
    max-height: 250px;
    overflow: auto;
  }

  .date-field {
    text-align: right;
  }

  .dialog-footer {
    border-top: 1px solid #2e3339;
    margin: 16px;
  }
`;
